module.exports = __webpack_public_path__ + "static/media/RightArrow.6b61e6f3.svg";